// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39ptz","inner":"Footer_inner__2uMM0"};